import { useTranslation } from "react-i18next";

import { formatDateToTimeString } from "../lib/formatters";
import { StatusChip, StatusChipVariant } from "./StatusChip";

export const LastUpdateChip = ({
  label,
  lastUpdateTime,
  variant = "info",
}: {
  label?: string;
  lastUpdateTime: Date | null | undefined;
  variant?: StatusChipVariant;
}) => {
  const { t } = useTranslation();

  if (!lastUpdateTime) return null;
  return (
    <StatusChip variant={variant}>
      {label ?? t("general.lastUpdate")} {formatDateToTimeString(lastUpdateTime)}
    </StatusChip>
  );
};
